import DestacatMedia from './DestacatMedia';
import DestacatMediaSkeleton from './DestacatMediaSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatMediaSkeleton /> : <DestacatMedia {...props} />;
}
